import React, { } from 'react';
import ContainerCard from 'components/Containers/Card/ContainerCard';
import HeaderCard from 'components/Containers/Card/HeaderCard';
import {
  FieldArray, Form, Formik,
} from 'formik';
import {
  Box,
  CardContent,
} from '@mui/material';
import GroupButton from 'components/Buttons/ButtonGroup';
import { pondSchema } from './schemas';
import AlertDialog from 'components/Dialogs/dialogMain';
import { usePhysicalPond } from 'hooks/usePhysicalPond';
import InputGroup from './components/InputGroup';

const emptyPonds = {
  capacity: '',
  description: '',
  type: '',
  status: '',
  system: '',
  protocol: '',
  depth: null,
};

function Pond() {
  const initialValues = {
    ponds: [
      emptyPonds,
    ],
  };

  const {
    classes,
    showAlertDialog,
    setShowAlertDialog,
    checkPondWithSameName,
    handleSubmit,
    openProgress,
    id,
    checkIfcopy,
    existsId,
    disable,
    isInCycle,
    recoverPond,
  } = usePhysicalPond();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={pondSchema}
      onSubmit={handleSubmit}
    >
      {({ values, setValues }) => {
        const hasPonds = values.ponds && values.ponds.length > 0;
        const handleAdd = () => {
          setValues({
            ...values,
            ponds: [
              ...values.ponds,
              { ...emptyPonds },
            ],
          });
        };

        checkPondWithSameName(values);

        const sizeArrayValues = values.ponds.length;

        return (
          <ContainerCard loading={openProgress}>
            {showAlertDialog && (
              <AlertDialog
                open={showAlertDialog}
                setOpen={setShowAlertDialog}
                positiveCall={() => {
                  setShowAlertDialog(false);
                }}
                route="/cycles"
                message="Cadastro não efetuado. Existe um viveiro cadastrado com esse nome. "
                text="Falha"
                button="OK"
                noCancel
              />
            )}
            <Form noValidate>
              <div className={classes.root}>
                <HeaderCard
                  title="Dados do Viveiro"
                  tooltipText="Essa tela serve para cadastrar as informações dos viveiros
                  da fazenda e escolher seu tipo, sistema de produção e
                  protocolo de trabalho."
                  handleAdd={(!existsId) && handleAdd}
                />
                <FieldArray name="ponds">
                  {({ remove }) => (
                    <CardContent style={{
                      padding: '0rem', display: 'flex', flexDirection: 'column', gap: 26,
                    }}
                    >
                      {hasPonds && (
                        values.ponds.map((item, index) => (
                          <Box
                            key={index}
                            sx={{
                              border: '1px solid #BFC9C2',
                              borderRadius: '16px',
                              background: '#F8FAF6',
                              boxShadow: 'none',
                              p: 2,
                            }}
                          >
                            <InputGroup
                              descriptionPonds={values.ponds.map(({ description }) => description)}
                              item={item}
                              index={index}
                              onRemove={() => remove(index)}
                              disableRemoveButton={sizeArrayValues === 1}
                              recoverPond={recoverPond}
                              id={id}
                              existsId={existsId}
                              checkIfcopy={checkIfcopy}
                              setValues={setValues}
                            />
                          </Box>
                        ))
                      )}
                    </CardContent>
                  )}
                </FieldArray>
              </div>
              <GroupButton
                deleteRoute="/ponds/"
                routeDelete="/ponds"
                returnRoute="/ponds"
                displayTooltip
                id={id}
                disable={disable}
                disableTemporary={!!isInCycle}
                message="A exclusão desse Viveiro pode levar a exclusão de objetos que dependam dele. Tem certeza que deseja excluir?"
              />
            </Form>
          </ContainerCard>
        );
      }}
    </Formik>
  );
}

export default Pond;
